import ReactPDF, { View, Page, Text, StyleSheet, Font, Image, Link } from "@react-pdf/renderer";
import { AnalyzeData, PDFData, Question, RiskJustification, TotalRisk } from "../components/Violations";
import { styles } from "./pdfstyles";

export interface ITableProps {
    pdf: AnalyzeData;
    riskTotal: TotalRisk;
}

export default function ViolationsPDF({pdf, riskTotal}: ITableProps) {

    Font.register({
        family: "Roboto",
        src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
    })

    return (
        <ReactPDF.Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.title}>
                    <Image src="https://e-rodo.eu/images/ready/waga_naruszen.jpg" style={{height: "171px"}} />
                </View>
                <View style={styles.title}>
                    <Text>Kalkulator wagi naruszeń ochrony danych osobowych RODO</Text>
                </View>
                <View style={styles.normalText}>
                    <Text>Aby ułatwić ocenę, przedstawiamy narzędzie, które pozwoli dokonać oceny, krok po kroku. Jest to narzędzie pomocne dla osób odpowiedzialnych za zgłoszenie, które nie muszą mieć wystarczającego doświadczenia w dziedzinie ochrony danych osobowych, a chcą wywiązać się z obowiązków wynikających z przepisów RODO.</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>Waga naruszenia</Text>
                    <Text style={styles.header}>{riskTotal.name}</Text>
                    <Text>{riskTotal.details}</Text>
                    <Text style={styles.header}>Obowiązek zgłoszenia</Text>
                    <Text style={styles.header}>{riskTotal.reportObligation}</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>1) Opis naruszenia</Text>
                    <Text style={styles.header}>Data naruszenia</Text>
                    <Text>{pdf.infringementDate}</Text>
                    <Text style={styles.header}>Nazwa administratora danych, którego dotyczyło naruszenie</Text>
                    <Text>{pdf.admin}</Text>
                    <Text style={styles.header}>Opis na czym polegało naruszenie</Text>
                    <Text>{pdf.infringement}</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>2) Zakres ujawnionych danych</Text>
                    <Text style={styles.header}>Dane zwykłe</Text>
                    {questionText(pdf.question2[0])}
                    <Text style={styles.header}>Dane dotyczące zachowań i preferencji</Text>
                    {questionText(pdf.question2[1])}
                    <Text style={styles.header}>Dane finansowe</Text>
                    {questionText(pdf.question2[2])}
                    <Text style={styles.header}>Dane szczególnej kategorii</Text>
                    {questionText(pdf.question2[3])}
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>3) Czynniki wpływające na poziom ryzyka</Text>
                    <Text style={styles.header}>Duża liczba osób, których dane zostały ujawnione</Text>
                    {questionText(pdf.question3[0])}
                    <Text style={styles.header}>Duży zakres danych na temat poszczególnych osób</Text>
                    {questionText(pdf.question3[1])}
                    <Text style={styles.header}>Specyfika osób, których dane dotyczą</Text>
                    {questionText(pdf.question3[2])}
                    <Text style={styles.header}>Specyfika administratora danych</Text>
                    {questionText(pdf.question3[3])}
                    <Text style={styles.header}>Szczególny charakter danych</Text>
                    {questionText(pdf.question3[4])}
                    <Text style={styles.header}>Publiczna dostępność danych przed ich ujawnieniem</Text>
                    {questionText(pdf.question3[5])}
                    <Text style={styles.header}>Aktualność i poprawność danych</Text>
                    {questionText(pdf.question3[6])}
                    <Text style={styles.header}>Zaufani odbiorcy</Text>
                    {questionText(pdf.question3[7])}
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>4) Ocena prawdopodobieństwa identyfikacji osób, których dane dotyczą</Text>
                    <Text>{pdf.identityProbability.text}</Text>
                    <Text>{pdf.identityProbability.justification}</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>5) Jaki charakter miało naruszenie?</Text>
                    <Text style={styles.header}>Ujawnienie danych i utrata poufności</Text>
                    {riskText(pdf.confidentialLoss)}
                    <Text style={styles.header}>Dane zmienione (utrata integralności)</Text>
                    {riskText(pdf.integrityLoss)}
                    <Text>{pdf.integrityLoss.justification}</Text>
                    <Text style={styles.header}>Dane niedostępne (utrata dostępności)</Text>
                    {riskText(pdf.availabilityLoss)}
                    <Text style={styles.header}>Celowe działanie?</Text>
                    {riskText(pdf.intentionalAction)}
                </View>
                <View style={styles.mt2}>
                    <Text style={styles.textTitle}>ZASTRZEŻENIE</Text>
                    <Text style={styles.text}>Wyniki podane przez kalkulator są orientacyjne i pomocnicze, nie mogą być jedyną podstawą do podejmowania działań ani do pełnej diagnozy stanu faktycznego. Nie ponosimy jakiejkolwiek odpowiedzialności za skutki uboczne korzystania z kalkulatora. Dodatkowe szczegóły w zakresie przepisów prawa: art. 24 i art. 32 RODO. Potrzebujesz pomocy? Skontaktuj się z nami i umów się na spotkanie.</Text>
                </View>
                <View>
                    <Text style={styles.textTitle}>WSPARCIE</Text>
                    <Text style={styles.text}>Wspieramy w zakresie ochrony danych i obsługi naruszeń ochrony danych oraz w ich klasyfikacji.</Text>
                </View>
                <View style={styles.center}>
                    <Link src="https://e-rodo.eu/kontakt.php#contact-section">
                        <Image src="https://e-rodo.eu/images/ready/PDF.jpg" style={{height: "171px"}} />
                    </Link>
                </View>
            </Page>
        </ReactPDF.Document>
    )
}

const riskText = (risk: RiskJustification) => {
    if(risk.value) {
        return (
            <>
                <Text>{risk.text}</Text>
                <Text>{risk.justification}</Text>
            </>
        )
    }
    else return <Text>Nie dotyczy</Text>
}

const questionText = (question: Question) => {

    if(question.value) {
        return (
            <>
                <Text>TAK, Wartość: {question.risk?.value}</Text>
                <Text>{question.justification}</Text>
            </>
        )
    }

    return (
        <Text>NIE</Text>
    )
}